var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"MainPage"},[_c('Articles',{attrs:{"className":"MainPage-Articles"}}),_c('Tags',{attrs:{"className":"MainPage-Tags"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }